module.exports = __webpack_public_path__ + "archivist_wow.gif?b906cab4cef34b2010e666ab541646ee";


//////////////////
// WEBPACK FOOTER
// ./src/img/animazioni/archivist_wow.gif
// module id = 375
// module chunks = 0